import React, { useMemo, useRef, useState, useEffect } from 'react';


import ProductCard from '../components/ProductCard';
import Pagination from '../components/Pagination';
import { supabase } from '../supabaseClient';

const CategoryPage = ({ category, onAddToCart, onProductClick }) => {
  const [products, setProducts] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [selectedSubcategoria, setSelectedSubcategoria] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage, setProductsPerPage] = useState(10);

  // Leer la página desde la URL
  useEffect(() => {
    
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page'));
    if (!isNaN(page) && page > 0) {
      setCurrentPage(page);
    }
  }, []);

  // Escuchar el botón atrás del navegador
  useEffect(() => {
    const handlePopState = () => {
      const params = new URLSearchParams(window.location.search);
      const page = parseInt(params.get('page'));
      if (!isNaN(page) && page > 0) {
        setCurrentPage(page);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Cargar productos desde Supabase
  useEffect(() => {
     
    const fetchProducts = async () => {
      const query = supabase
        .from('products')
        .select('*')
        .eq('category', category);

      if (selectedSubcategoria) {
        query.eq('subcategoria', selectedSubcategoria);
      }

     query.order('id', { ascending: true });


      const { data, error } = await query;

      if (error) {
        console.error('Error al cargar productos:', error);
      } else {
        setProducts(data);
        setCurrentPage(1);
        window.history.pushState({}, '', `?page=1`);
      }
    };

    fetchProducts();
  }, [category, selectedSubcategoria]);

  // Cargar subcategorías únicas de la categoría actual
  useEffect(() => {
     setSelectedSubcategoria(''); // Reiniciar subcategoría al cambiar de categoría
    const fetchSubcategorias = async () => {
      const { data, error } = await supabase
        .from('products')
        .select('subcategoria')
        .eq('category', category);

      if (error) {
        console.error('Error al cargar subcategorías:', error);
      } else {
        const unique = Array.from(new Set(data.map((item) => item.subcategoria).filter(Boolean))).sort();
        setSubcategorias(unique);
      }
    };

    fetchSubcategorias();
  }, [category]);

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.history.pushState({}, '', `?page=${pageNumber}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleClearFilter = () => {
    setSelectedSubcategoria('');
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      {/* Filtros */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <div className="flex items-center gap-2">
          <label htmlFor="subcategoria" className="text-gray-700">Subcategoría:</label>
          <select
            id="subcategoria"
            value={selectedSubcategoria}
            onChange={(e) => setSelectedSubcategoria(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5A61E5]"
          >
            <option value="">Todas</option>
            {subcategorias.map((sub, index) => (
              <option key={index} value={sub}>{sub}</option>
            ))}
          </select>
        </div>
        <button
          onClick={handleClearFilter}
          className="bg-gray-100 hover:bg-gray-200 text-sm text-gray-800 px-4 py-2 rounded-lg transition-colors"
        >
          Limpiar Filtros
        </button>
        <div className="flex items-center gap-2 ml-auto">
          <label htmlFor="productsPerPage" className="text-gray-700">Mostrar:</label>
          <select
            id="productsPerPage"
            value={productsPerPage}
            onChange={(e) => setProductsPerPage(Number(e.target.value))}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5A61E5]"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value={products.length}>Todos</option>
          </select>
        </div>
      </div>

      {/* Productos */}
      {currentProducts.length === 0 ? (
        <p className="text-gray-600 text-lg text-center py-8">No hay productos en esta categoría.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-6">
          {currentProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={onAddToCart}
              onProductClick={onProductClick}
            />
          ))}
        </div>
      )}

      {/* Paginación */}
      {products.length > productsPerPage && (
        <Pagination
          productsPerPage={productsPerPage}
          totalProducts={products.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      )}
    </div>
  );
};

export default CategoryPage;
